export default __webpack_public_path__ + "static/media/green_arrow.d590df8c.svg";